import { faMagnifyingGlass } from "@fortawesome/pro-solid-svg-icons";
import {
  FontAwesomeIcon,
  type FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

const MagnifyingGlassIcon = ({
  ...props
}: Omit<FontAwesomeIconProps, "icon">) => (
  <FontAwesomeIcon icon={faMagnifyingGlass} {...props} title={undefined} />
);

export { MagnifyingGlassIcon };
